<app-page-layout
  [title]="pageTitle$ | async"
  [parentTitle]="'Kalver Selectie Programma'"
  parentUri="/app/animal-selections"
  menuBtnWhen="lg"
  [loading]="animalsTabLoading"
>
  <div class="animal-selection-shell">
    <ion-tab-bar mode="md" color="primary">
      <ion-tab-button tab="details" routerLink="details" routerLinkActive="tab-selected">
        <fa-icon [icon]="['fal', 'book-section']" size="2x"></fa-icon>
        Gegevens
      </ion-tab-button>
      <ion-tab-button tab="animals" routerLink="animals" routerLinkActive="tab-selected">
        <fa-icon [icon]="['fal', 'cow']" size="2x"></fa-icon>
        Dieren
      </ion-tab-button>
    </ion-tab-bar>

    <div class="tab-content">
      <router-outlet></router-outlet>

      <div class="animals-tab-loading" *ngIf="animalsTabLoading" aria-busy="true" aria-label="Dieren laden">
        <ion-progress-bar type="indeterminate" color="primary"></ion-progress-bar>
        <div class="skeleton-header">
          <span class="skeleton-header-spacer"></span>
          <span class="col-werknr">{{ isApp ? 'Werknr.' : 'Levensnummer' }}</span>
          <span class="col-age">Leeftijd</span>
          <span class="col-gender">Geslacht</span>
          <span class="col-color">Kleur</span>
        </div>
        <div class="skeleton-body">
          <div
            class="skeleton-row"
            *ngFor="let i of skeletonRows"
            [class.skeleton-row-alt]="i % 2 === 1"
          >
            <span class="skeleton-mark"></span>
            <span class="skeleton-cell col-werknr"></span>
            <span class="skeleton-cell col-age"></span>
            <span class="skeleton-cell col-gender"></span>
            <span class="skeleton-cell col-color"></span>
          </div>
        </div>
        <div class="skeleton-footer">
          <span class="skeleton-cell skeleton-footer-text"></span>
        </div>
      </div>
    </div>
  </div>
</app-page-layout>
